// extracted by mini-css-extract-plugin
export default {"icon":"LinkingForm_icon__SDiDp","close-icon":"LinkingForm_close-icon__NofI7","captiv8Icon":"LinkingForm_captiv8Icon__5g4K9"};